import React, { useState } from 'react';
import { ButtonUI, DeleteDialogUI, DialogUI, FileTabUI, FileUploadUI } from '../Interface';
import { Box } from '@mui/material';
import taskListService from '../../service/taskList.service';

const TaskListAttachmentDialog = ({ handleClose, open, setRefetchTable, apiRef, user, row, editable }) => {
  const { selectedRow, setSelectedRow } = row;
  const [deleteDialog, setDeletDialog] = useState(false);
  const [removeElement, setRemoveElement] = useState(null);
  const [filesToUpload, setFilesToUpload] = useState([]);

  const handleUpload = async () => {
    const uploadedFiles = [];

    for (const f of filesToUpload) {
      const attachments = await taskListService.uploadFile(f.file, selectedRow.id, user.userId);
      uploadedFiles.push(...attachments);
    }

    const updatedRow = {
      ...selectedRow,
      taskListAttachment: [...(selectedRow.taskListAttachment || []), ...uploadedFiles],
    };

    apiRef.current.updateRows([updatedRow]);

    setRefetchTable(true);
    setFilesToUpload([]);
    handleClose();
  };

  const handleFilesChange = (newFiles) => {
    setFilesToUpload(newFiles);
  };

  const hideDeleteDialog = () => {
    setDeletDialog(false);
  };

  const handleRemoveElement = () => {
    taskListService.deleteFile(removeElement, user.userId).then(() => {
      const updatedRow = {
        ...selectedRow,
        taskListAttachment: (selectedRow.taskListAttachment || []).filter(
          (attachment) => attachment.id !== removeElement
        ),
      };

      apiRef.current.updateRows([updatedRow]);

      const updated = apiRef.current.getRow(updatedRow.id);
      if (updated) {
        setSelectedRow(updated);
      }

      setRemoveElement(null);
      setDeletDialog(false);
      setRefetchTable(true);
    });
  };

  const handleDelete = (data) => {
    setRemoveElement(data.id);
    setDeletDialog(true);
  };

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Csatolmányok"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '800px',
          },
        },
      }}
    >
      {editable && <FileUploadUI onFilesChange={handleFilesChange} />}
      <Box mt="1rem">
        <FileTabUI savedFiles={selectedRow.taskListAttachment ?? []} handleDelete={handleDelete} />
      </Box>
      <Box display="flex" gap={3} justifyContent="center" mt="1rem">
        <ButtonUI
          text="Feltöltés"
          className="bg-success flex gap-2 items-center"
          type="button"
          disabled={!filesToUpload?.length > 0}
          onClick={handleUpload}
        />
        <ButtonUI
          text="Mégse"
          className="bg-danger flex items-center gap-2"
          type="button"
          onClick={() => handleClose()}
        >
          Bezárás
        </ButtonUI>
      </Box>
      <DeleteDialogUI
        handleRemoveElement={handleRemoveElement}
        show={deleteDialog}
        onHide={() => {
          hideDeleteDialog();
          setRemoveElement(null);
        }}
      />
    </DialogUI>
  );
};

export default TaskListAttachmentDialog;
